// extracted by mini-css-extract-plugin
export var optionGrid = "_a2-7";
export var optionList = "_a2-6";
export var questionsBlock = "_a2-9";
export var spacer = "_a2-5";
export var stepCenteredContent = "_a2-3";
export var stepInner = "_a2-0";
export var stepInnerFullWidth = "_a2-1";
export var stepInnerLockScroll = "_a2-2";
export var stepTransitionFrame = "_a2-4";
export var welcomeBlock = "_a2-8";